var map = {
	"./decidim/avatar-multiuser.png": 96840,
	"./decidim/brands/facebook.svg": 74070,
	"./decidim/brands/google.svg": 1495,
	"./decidim/brands/twitter-x.svg": 67452,
	"./decidim/cc-badge.png": 18306,
	"./decidim/decidim-logo.svg": 57290,
	"./decidim/default-avatar.svg": 90646,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 11146,
	"./decidim/icons.svg": 89849,
	"./decidim/pattern.png": 26934,
	"./decidim/placeholder-card-g.svg": 64891,
	"./decidim/placeholder-card-l.svg": 31216,
	"./decidim/placeholder.jpg": 89559,
	"./decidim/remixicon.symbol.svg": 6319,
	"./decidim/vendor/social-share-button/douban.svg": 73502,
	"./decidim/vendor/social-share-button/email.svg": 70587,
	"./decidim/vendor/social-share-button/facebook.svg": 49405,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 82055,
	"./decidim/vendor/social-share-button/hacker_news.svg": 96351,
	"./decidim/vendor/social-share-button/linkedin.svg": 44643,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 59148,
	"./decidim/vendor/social-share-button/pinterest.svg": 14189,
	"./decidim/vendor/social-share-button/reddit.svg": 62461,
	"./decidim/vendor/social-share-button/telegram.svg": 44900,
	"./decidim/vendor/social-share-button/tumblr.svg": 22219,
	"./decidim/vendor/social-share-button/twitter.svg": 80762,
	"./decidim/vendor/social-share-button/vkontakte.svg": 20900,
	"./decidim/vendor/social-share-button/wechat.svg": 74751,
	"./decidim/vendor/social-share-button/whatsapp.svg": 18751,
	"./decidim/vendor/social-share-button/x.svg": 26779,
	"./decidim/vendor/social-share-button/xing.svg": 74989
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47133;